import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Draggable } from "@hello-pangea/dnd";
import moment from "moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import { LabelList } from "../../common/LabelList";
import LabelIcon from "@mui/icons-material/Label";

const InboxData = ({
    item,
    getTaskMailIndbox,
    onCheckboxClick,
    isShiftPressedMail,
    onDragEnd,
    setSelectedMailId,
    setInboxFilterMailData,
    columns,
    index,
}) => {
    let matchedColumn;
    if (columns?.length > 0 && item?.BoardList?.id) {
        matchedColumn = columns.find(
            (column) => column?.id === item?.BoardList?.id
        );
    } else {
        matchedColumn = undefined;
    }
    const [labelAnchorEl, setLabelAnchorEl] = useState(null);

    const [isHovered, setIsHovered] = useState(false);
    const [isSelectedMail, setIsSelectedMail] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const [isUnread, setIsUnread] = useState(item?.isUnread || false);
    const navigate = useNavigate();
    const [isMailSelected, setIsMailSelected] = useState(false);
    const [mailId, setMailId] = useState(false);

    const { deadlineDate, selectedBoardId } = useSelector(
        (state) => ({
            deadlineDate: state.redux.deadlineDate,
            selectedBoardId: state.redux.selectedBoardId,
        }),
        (prev, next) =>
            prev.deadlineDate === next.deadlineDate &&
            prev.selectedBoardId === next.selectedBoardId
    );

    const handleClick = async (event, id, item) => {
        if (
            event.target.closest(".bi.bi-trash") ||
            event.target.closest(".bi.bi-file-arrow-down") ||
            event.target.closest(".bi.bi-clock")
        ) {
            return;
        }
        setIsMailSelected(true);
        setIsSelectedMail(true);
        try {
        } catch (error) {
            console.error("Error fetching email status:", error);
        }
        await updateStatusTask(item?.gmailMessageId, "read");
        setSelectedMailId(item.gmailMessageId);
    };

    const deleteTaskMail = async (id) => {
        try {
            const data = { taskstatus: "inProgress" };
            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/email/deletemail/${id}`,
                { data }
            );
            if (response) {
                setInboxFilterMailData((prev) =>
                    prev.filter((email) => email.id !== id)
                );
                setShowPopup(false);
                await getTaskMailIndbox();
            }
        } catch (error) {
            console.error("Error deleting task email:", error);
        }
    };

    const updateStatusTask = async (gmailMessageId, status) => {
        const data = { messageRead: status };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/email/updatedMessageRead/${gmailMessageId}`,
                data
            );
            if (response) {
                setInboxFilterMailData((prev) =>
                    prev.map((mail) =>
                        mail.gmailMessageId === gmailMessageId
                            ? { ...mail, messageRead: status }
                            : mail
                    )
                );
                await getTaskMailIndbox();
                setShowPopup(false);
            }
        } catch (error) {
            console.error("Error updating task status:", error);
        }
    };

    const handleCheckboxChange = () => {
        onCheckboxClick();
    };

    const handleContextMenu = (event) => {
        event.preventDefault();
        setPopupPosition({ x: event.clientX, y: event.clientY });
        setShowPopup(true);
    };

    const handlePopupClose = () => {
        setShowPopup(false);
    };

    const handleMarkAsUnread = async () => {
        await updateStatusTask(item?.gmailMessageId, "unread");
        setIsUnread(true);
        handlePopupClose();
    };

    const handleMarkAsRead = async () => {
        await updateStatusTask(item?.gmailMessageId, "read");
        setIsUnread(false);
        handlePopupClose();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".popup")) {
                handlePopupClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (item.isNew) {
            const timer = setTimeout(() => {
                const element = document.getElementById(item.id);
                if (element) {
                    element.classList.remove("blinking-effect");
                }
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [item.isNew, item.id]);
    const labelList = (item?.labels || "").split(",").map(l => l.trim());
    const cleanedLabels = labelList
        .filter(l => l !== "TRASH" && l !== "UNREAD");

    let displayLabels = [];

    if (cleanedLabels.some(l => l.toUpperCase() === "INBOX")) {
        displayLabels = ["INBOX"];

        // Priority 2: API-Reply → means SENT
    } else if (cleanedLabels.some(l => l === "API-Reply")) {
        displayLabels = ["SENT"];

        // Else fallback: show ONLY first available label
    } else if (cleanedLabels.length > 0) {
        displayLabels = [cleanedLabels[0]];
    } else {
        displayLabels = [];
    }

    const toCamelCase = (str) =>
        str
            .toLowerCase()
            .split(/[_-]/g)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

    return (
        <Draggable draggableId={String(item?.gmailMessageId || item.id)} index={index}>
            {(provided, snapshot) => (
                <div
                    id={item.id}
                    className={`${item.isNew ? "blinking-effect" : ""}`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                        ...provided.draggableProps.style,
                        opacity: snapshot.isDragging ? 0.5 : 1,
                    }}
                >
                    <div
                        key={item.id}
                        onClick={async (e) => {
                            await updateStatusTask(item?.gmailMessageId, "read");
                            navigate(`/detail/${item.id}`, {
                                state: {
                                    selectedMail: item,
                                    deadlineDate: deadlineDate,
                                    taskID: item.id,
                                    clickMailTask: true,
                                    type: "Gmail",
                                    openTaskDataSidebar: true,
                                    currentTask: item,
                                    boardId: selectedBoardId,
                                    isInboxVisible: true,
                                    boardName: matchedColumn?.boardName || ""
                                },
                            });
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        onContextMenu={handleContextMenu}
                        style={{
                            borderLeft: mailId ? "5px solid #1B72E8" : "5px solid transparent",
                            backgroundColor: isHovered ? "#fafafa" : "white",
                            position: "relative",
                        }}
                        className={`max-w-sm p-2 hover:bg-[#FAFAFA] ${item?.subEmail?.messageRead === "unread" ||
                            item?.messageRead === "unread" ||
                            item?.Email?.messageRead === "unread"
                            ? "active-bg"
                            : "bg-white"
                            }`}
                    >
                        <div className="grid grid-cols-[8%_auto] items-start gap-1">
                            <div className="h-[26px]"></div>
                            <div className="relative">
                                <div className="grid grid-cols-[70%_auto] items-center text-black">
                                    <h2
                                        className={`text-ellipse  text-[13.6px] ${item?.subEmail?.messageRead === "unread" ||
                                            item?.messageRead === "unread" ||
                                            item?.Email?.messageRead === "unread"
                                            ? "font-bold"
                                            : "font-normal"
                                            }`}
                                    >
                                        {item?.subEmail?.subject || item?.subject || item?.title}
                                    </h2>
                                    <div className="h-[26px]">
                                        <div className="text-right">
                                            <span
                                                className={`date-time text-black ${item?.subEmail?.messageRead === "unread" ||
                                                    item?.messageRead === "unread" ||
                                                    item?.Email?.messageRead === "unread"
                                                    ? "font-bold text-[11.56px]"
                                                    : "font-normal"
                                                    }`}
                                            >
                                                {item?.subEmail?.createdAtEmail
                                                    ? moment(item.subEmail.createdAtEmail).format("MMM DD, h:mm")
                                                    : item?.createdAtEmail
                                                        ? moment(item.createdAtEmail).format("MMM DD, h:mm")
                                                        : "No Date"}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                    <div
                                        className="d-inline-flex align-items-center text-white rounded-1 border px-2 py-1 bg-[#20212414] flex-wrap"
                                        style={{ fontSize: "11px" }}
                                    >
                                        {displayLabels.map((label, index) => (
                                            <span
                                                key={index}
                                                className="text-dark d-flex align-items-center text-truncate"
                                            >
                                                {toCamelCase(label)}


                                                {index !== displayLabels.length - 1 && (
                                                    <span className="mx-2 text-muted">|</span>
                                                )}
                                            </span>
                                        ))}
                                    </div>
                                    <LabelIcon onClick={(e) => {
                                        e.stopPropagation();
                                        setLabelAnchorEl(e.currentTarget);
                                    }}
                                        onMouseDown={(e) => e.stopPropagation()} />
                                </div>


                                <div className="grid grid-cols-[80%_auto] items-center text-ellipsis !text-[13.6px]">
                                    <h6
                                        className={`text-black ${item?.subEmail?.messageRead === "unread" ||
                                            item?.messageRead === "unread" ||
                                            item?.Email?.messageRead === "unread"
                                            ? "font-bold"
                                            : "font-normal"
                                            }`}
                                    >
                                        {item?.subEmail?.name || item?.name || "Manual task"}
                                    </h6>

                                    {item?.BoardList?.coloum ? (
                                        <div
                                            className="w-100 flex gap-[8px] justify-content-center rounded-4 items-end ml-2 board-item1"
                                            style={{
                                                backgroundColor: matchedColumn?.borderColor ?? "#E8E8E8",
                                            }}
                                            title={item?.BoardList?.coloum}
                                        >
                                            {item?.BoardList?.coloum?.length > 6
                                                ? item.BoardList.coloum.slice(0, 6) + "..."
                                                : item?.BoardList?.coloum}
                                        </div>
                                    ) : (
                                        <div className="flex gap-[8px] justify-end items-center">
                                            {(item?.subEmail?.messageRead === "unread" ||
                                                item?.messageRead === "unread" ||
                                                item?.Email?.messageRead === "unread") && (
                                                    <div className="unread-red-dot"></div>
                                                )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>



                        <div
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <LabelList
                                anchorEl={labelAnchorEl}
                                setAnchorEl={setLabelAnchorEl}
                                selectedEmailID={item?.id}
                            />
                        </div>
                    </div>

                    {showPopup && (
                        <div
                            className="popup absolute z-10 p-1 bg-[#f5f5f5] border shadow-lg rounded-[4px] !text-[11.56px]"
                            style={{ top: popupPosition.y, left: popupPosition.x }}
                        >
                            {item?.messageRead === "unread" && (
                                <button
                                    onClick={handleMarkAsRead}
                                    className="block px-2 py-1 text-black"
                                >
                                    Mark as Read
                                </button>
                            )}
                            {item?.messageRead === "read" && (
                                <button
                                    onClick={handleMarkAsUnread}
                                    className="block px-2 py-1 text-black"
                                >
                                    Mark as Unread
                                </button>
                            )}
                            <button
                                onClick={() => deleteTaskMail(item?.id)}
                                className="block px-2 py-1 text-red-500"
                            >
                                Delete
                            </button>
                        </div>
                    )}
                </div>
            )}
        </Draggable>
    );
};

InboxData.propTypes = {
    item: PropTypes.object.isRequired,
    getTaskMailIndbox: PropTypes.func.isRequired,
    onCheckboxClick: PropTypes.func.isRequired,
    isShiftPressedMail: PropTypes.bool,
    setIsShiftPressedMail: PropTypes.func,
    taskList: PropTypes.array,
    onDragEnd: PropTypes.func.isRequired,
    selectedMailId: PropTypes.string,
    setSelectedMailId: PropTypes.func,
    index: PropTypes.number.isRequired,
};

export default InboxData;

